const Style = {
  logoSection: `invisible md:visible flex flex-col items-start justify-center w-1/3 bg-[url('components/layout/auth/images/illustration.svg')] bg-cover bg-center`,
};

export default Style;
